import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import Agency from './Agency'

interface AgenciesProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const Agencies = (props: AgenciesProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Agencies">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Agencies"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="agencyIds"
          // @ts-expect-error TS2322
          entityListItemComponent={Agency}
        />
      </Box>
    </DashboardModule>
  )
}

export default Agencies
